<template>
  <div>

    <vx-card title="" :hide-filter="true" :is-filter="true" :has-quick-search="true" class="mb-8" :init-collapsed="true" :collapse-action="true">

      <template slot="actions">
        <vx-input-group>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="primary" type="border" @click="importMemberExcel()">{{ $t('register') }}</vs-button>
            </div>
          </template>
          <input type="file" class="vs-inputx vs-input--input normal" id="file" ref="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="handleFileUpload()">
        </vx-input-group>
      </template>

      <div class="vx-row">


      </div>

      <template slot="footer">

      </template>

    </vx-card>

    <vx-card id="memberImportDataContainer" :title="$t('import_members')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-member-tab-nav></shared-member-tab-nav>
      </template>

      <template>
        <div>
          <vs-button class="m-2" color="success" type="filled" icon-pack="feather" icon="icon-download" @click="downloadMemberExcel">{{ $t('sample_member_excel_file_download') }}</vs-button>
          <br/>
          <p>{{ $t('member_import_instruction_1') }}</p>
          <p>{{ $t('member_import_instruction_2') }}</p>
          <p>{{ $t('member_import_instruction_3') }}</p>
          <p>{{ $t('member_import_instruction_4') }}</p>
          <br/>
          <br/>
        </div>
      </template>

    </vx-card>

  </div>
</template>

<script>
import SharedMemberTabNav from '@/views/Shared/Members/TabNav'
import Member from '@/models/Member'

export default {
  name: 'User.Members.Import',
  components: {
    SharedMemberTabNav
  },
  data () {
    return {
      companyId: '',
      language: '',
      file: ''
    }
  },
  mounted () {
    this.companyId = this.$store.getters.userInfo !== null && this.$store.getters.userInfo.company !== null ? this.$store.getters.userInfo.company.id : ''
  },
  methods: {
    async downloadMemberExcel (e) {
      e.preventDefault()
      try {
        this.language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        await Member.downloadSampleImportFile(this.companyId, this.language)
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async importMemberExcel () {
      this.$vs.loading({container: '#memberImportDataContainer'})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          if (document.getElementById('file').files.length) {

            await Member.import({ 'companyId': this.companyId, 'file': this.file })
            document.getElementById('file').value = ''
            this.file = ''

            this.$swalHelper.success({
              title: this.$t('upload_is_complete'),
              text: '',
              confirmButton: this.$t('confirm')
            })

          } else {
            await this.$swalHelper.error({
              title: '',
              text: this.$t('please_upload_xlsx_file'),
              confirmButton: this.$t('confirm')
            })
            this.$store.dispatch('setIsFormInProgress', false)
          }
        }
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e.message,
          confirmButton: this.$t('confirm')
        })
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#memberImportDataContainer > .con-vs-loading')
    }
  }
}
</script>

<style scoped>
.quick-search {
  min-width: 300px;
}
</style>
